import { useEffect } from 'react'
import Select from 'react-select'
import { AssetTypeDDLAPI, FinancialYearDDLAPI, MonthDDLAPI, WardNameDDLAPI } from '../../Redux/DDLSlice'
import { useDispatch, useSelector } from 'react-redux'
import { useAuthState } from '../../Helper/Context'
import { isDisabled } from '@testing-library/user-event/dist/utils'
import { AstricSign } from '../../Helper/AstricSign'

export const AssetTypeDataDDL = (props) => {
    const { AssetType, setAssetType, PopUpField, M_AssetTypeID, IsDisabled,Flag } = props

    const userDetails = useAuthState();
    const { UserID, token, } = userDetails.user
    const dispatch = useDispatch()

    // console.log(M_AssetTypeID)

    useEffect(() => {
        const data = { UserID, token }
        dispatch(AssetTypeDDLAPI({ data }))
    }, [])

    const { AssetTypeData } = useSelector(state => state.AssetTypeDDLData)

    useEffect(() => {
        handleAssetTypeDDL()
    }, [AssetTypeData])

    const handleAssetTypeDDL = () => {
        // console.log(DeptDDLDataa)
        if (AssetTypeData && AssetTypeData.table && AssetTypeData.table.length > 0) {
            let list = AssetTypeData.table.map((item, index) => ({
                value: item.m_AssetTypeID,
                label: item.assetTypeName,
            }))

            if (M_AssetTypeID) {
                setAssetType({
                    DDL: list,
                    ID: list[M_AssetTypeID - 1].value,
                    Label: list[M_AssetTypeID - 1].label,
                })
            } else {
                setAssetType({
                    DDL: list,
                    ID: 0,
                    Label: "Select...",
                })
            }
        }
        else {
            setAssetType({
                DDL: [],
                ID: 0,
                Label: "Select...",
            })
        }

    }

    return (
        <div className="form-group">
            <label className="d-block" htmlFor="NameofDepartment"><b>Asset Type {Flag && <AstricSign />} </b></label>
            <Select
                isClearable
                isDisabled={IsDisabled}
                // isRtl={isRtl}
                isSearchable
                maxMenuHeight={150}
                value={{ value: AssetType.ID, label: AssetType.Label }}
                onChange={(e) => {
                    e ?
                        setAssetType({ ...AssetType, ID: e.value, Label: e.label })
                        :
                        setAssetType({ ...AssetType, ID: 0, Label: "Select..." })

                }}
                options={AssetType.DDL}
            />
        </div>
    )
}